var chunkMapping = {
	"765": [
		765
	],
	"8594": [
		8594
	]
};
var idToExternalAndNameMapping = {
	"765": [
		"default",
		"./useLegacyAllAccountsRolesFromCurrentAccount",
		877
	],
	"8594": [
		"default",
		"./HeaderHomeNotification",
		5277
	]
};
var idToRemoteMap = {
	"765": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 877
		}
	],
	"8594": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 5277
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}